import React from 'react';
import ReactDOM from 'react-dom';
import Screen from '../ui/Screen';
const screenRoot = document.getElementById('screen-root') || document.body;
export const createEmpty = (options) => {


    const {
        closable = false,
        is_modal = false,
        component,
        title = "",
        offset = [0, 0],
        callback = () => { },
        signal = {}
    } = options

    const div = document.createElement('div');


    screenRoot.appendChild(div);

    const closeScreen = (e) => {
        callback(e);
        if (screenRoot.contains(div)) {
            ReactDOM.unmountComponentAtNode(div);
            screenRoot.removeChild(div);

        }
    };
    ReactDOM.render(
        <div style={{ "justifyContent": "left", "alignItems": "start" }} className='ui-blank-screen'>
            <div
                style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    margin: "0 auto",
                    paddingTop: "clamp(43px, calc((100vh - 514px) / 2), 67px)",
                    boxSizing: "border-box",
                }}
            >
                <div
                    style={{
                        height: "calc(100vh - 75px)",
                        maxHeight: "calc(100vh - clamp(0px, calc((100vh - 514px) / 2), 26px))",
                        width: "min(100%, 1440px)",
                        minWidth: "1180px",
                        minHeight: "557px",
                        backgroundColor: "#00000088",
                        flexShrink: 0,
                    }}
                >
                       {React.cloneElement(component, { callback: callback })}
                </div>
            </div>
        </div>, div);
};
